import { crudActions } from "@/services/CrudActions";
import { crudMdActions } from "@/services/CrudMdActions";
import apiClient from "@/services/ApiClient";

export default {
  ...crudActions("partes"),
  ...crudMdActions("partes"),
  createFacturaCityCommand(parteIds) {
    return apiClient.post("/partes/factura-city/pedidos", {
      parteIds,
    });
  },
  getAgentsList(id = undefined) {
    let path = "/tecnicos/list";
    if (id) path += `?parte_id=${id}`;
    return apiClient.get(path);
  },
  getArticles(id = undefined) {
    let path = `/article-families/list`;
    if (id) path += `?parte_id=${id}`;
    return apiClient.get(path);
  },
  generarAlbaran(id) {
    return apiClient.post(`/partes/generar-albaran/${id}`);
  },
  crearConServicio(data) {
    return apiClient.post('/partes/crear-con-servicio', data);
  },
};
